<div
    class="group-card flex flex-col rounded-xl border border-gray-200 bg-white shadow-sm hover:shadow-md transition-shadow overflow-hidden">

    <!-- Role accent bar -->
    <div class="h-1 w-full" [ngClass]="getRoleAccentClass(group.role)"></div>

    <!-- Header -->
    <div class="flex items-start justify-between px-4 pt-4 pb-2 gap-2">
        <div class="flex items-center gap-2 min-w-0">
            <div class="flex-shrink-0 w-9 h-9 rounded-lg flex items-center justify-center"
                [ngClass]="getRoleIconBg(group.role)">
                <mat-icon class="text-white" style="font-size:20px;width:20px;height:20px">group</mat-icon>
            </div>
            <h3 class="text-sm font-semibold text-gray-900 truncate leading-tight">{{ group.name || 'Unnamed Group' }}
            </h3>
        </div>
        <span class="flex-shrink-0 text-xs font-medium px-2 py-0.5 rounded-full"
            [ngClass]="getRoleBadgeClass(group.role)">
            {{ group.role || 'N/A' }}
        </span>
    </div>

    <!-- Stats -->
    <div class="grid grid-cols-2 gap-2 px-4 py-2">
        <div class="flex flex-col items-center justify-center bg-gray-50 rounded-lg py-2">
            <span class="text-lg font-bold text-gray-800">{{ group.activeMemberCount ?? 0 }}</span>
            <span class="text-[10px] text-gray-500 uppercase tracking-wide">Members</span>
        </div>
        <div class="flex flex-col items-center justify-center bg-gray-50 rounded-lg py-2">
            <span class="text-lg font-bold text-gray-800">{{ group.assignedParkingSpaceCount ?? 0 }}</span>
            <span class="text-[10px] text-gray-500 uppercase tracking-wide">Spaces</span>
        </div>
    </div>

    <!-- Members -->
    @if (group.operatorGroupMemberships && group.operatorGroupMemberships.length > 0) {
    <div class="px-4 pb-2">
        <p class="text-[10px] font-semibold text-gray-400 uppercase tracking-wide mb-1.5">Members</p>
        <app-group-member-list [memberships]="group.operatorGroupMemberships" [groupId]="group.id!"
            (memberRemoved)="onMemberRemoved($event)">
        </app-group-member-list>
    </div>
    }

    <!-- Assigned spaces -->
    @if (group.parkingSpaceOperators && group.parkingSpaceOperators.length > 0) {
    <div class="px-4 pb-2">
        <p class="text-[10px] font-semibold text-gray-400 uppercase tracking-wide mb-1.5">Assigned Spaces</p>
        <div class="flex flex-col gap-1">
            @for (psg of group.parkingSpaceOperators; track psg.id) {
            <div class="flex items-center justify-between bg-blue-50 border border-blue-100 rounded-lg px-2.5 py-1">
                <div class="flex items-center gap-1.5 min-w-0">
                    <mat-icon class="text-blue-500 flex-shrink-0"
                        style="font-size:14px;width:14px;height:14px">local_parking</mat-icon>
                    <span class="text-xs text-blue-800 font-medium truncate">{{ psg.parkingSpace?.name ||
                        psg.parkingSpaceId }}</span>
                </div>
                <button mat-icon-button color="warn" (click)="onUnassignParkingSpace(psg.parkingSpaceId!)"
                    matTooltip="Remove" class="!w-6 !h-6 !leading-6">
                    <mat-icon style="font-size:14px;width:14px;height:14px">close</mat-icon>
                </button>
            </div>
            }
        </div>
    </div>
    }

    <!-- Actions -->
    <div class="mt-auto px-4 pb-4 pt-2 flex flex-col gap-2">
        <button mat-stroked-button class="w-full !text-xs" (click)="onAddOperator()">
            <mat-icon class="!text-base">person_add</mat-icon>
            Add Operator
        </button>
        <button mat-stroked-button class="w-full !text-xs" (click)="onAssignParkingSpace()">
            <mat-icon class="!text-base">add</mat-icon>
            Assign Parking Space
        </button>
    </div>

</div>